import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'

import styled from '@emotion/styled'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import Elevation from '@segment/matcha/components/Elevation'

export interface VideoProps {
  url: string
}

const Video: FC<PropsWithChildren<VideoProps>> = ({ url }) => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)

  return (
    <StyledElevation elevation={7}>
      <VideoPlayerBase url={url} playing={playing} onPause={stop} onPlay={play}>
        {!playing && <VideoPlayer.BigPlayButton ariaLabel="Play Button" onClick={play} />}
        {!playing && (
          <VideoPlayerCover>
            <Cover />
          </VideoPlayerCover>
        )}
      </VideoPlayerBase>
    </StyledElevation>
  )
}

const StyledElevation = styled(Elevation)`
  padding-top: 56px;
  max-width: 800px;
`
const VideoPlayerCover = styled(VideoPlayer.Cover)`
  background: none;
`
const Cover = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
  width: 100%;
  height: 100%;
  opacity: 0.2;
`

export default Video
